/* eslint-disable */
import { Component, Fragment } from "react";
import { Modal, Row, Col, Tooltip,  TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { Utils, Http, API, _, Images, Constant, Trans } from "Helpers";
import Slider from "react-slick";
import { notify } from "react-notify-toast";
import { ReduxHOC } from "HOC";
import { Img } from "Components";


const { REACT_APP_SALARY_SUBFFIX } = process.env;
  const fullPositionName = [
  { "position_display_name": "Goalkeeper", "position_code": "GK" },
  { "position_display_name": "Defender", "position_code": "DF" },
  { "position_display_name": "Forward", "position_code": "FW" },
  { "position_display_name": "Midfielder", "position_code": "MF" }
]
const fullPositionNameCric = [
  { "position_display_name": "Wicket Keeper", "position_code": "WK" },
  { "position_display_name": "Batsman", "position_code": "BAT" },
  { "position_display_name": "All Rounder", "position_code": "AR" },
  { "position_display_name": "Bowler", "position_code": "BOW" }
];





class PlayerCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      posting: true,
      statsposting: true,
      isPlayerRoleView: true,
      MasterData: [],
      PlayerCardData: [],
      PlayerParam: {},
      SelectedWeek: this.props.SelectedWeekCard || null,
      is_single_player: Utils.isSinglePlayer(),
      CurrentLineup: props.root.CurrentLineup,
      constant_pos: Utils.getFormationInitial(),
      SelectedLeague: Utils.getMultiLeg(),
      AppMasterData: props.root.AppMasterData,
      activeTab:'1',
      FixturesList:[],
      CurrentFixtuerSelected:'',
      openingItem: '',
      opening: false,
      matchData: [],
      totals: {
        pts: 0,
        mp: 0,
        gs: 0,
        a: 0,
        cs: 0,
        gc: 0,
        og: 0,
        ps: 0,
        pm: 0,
        yc: 0,
        rc: 0,
        s: 0,
      },
      tooltipOpen:{},
      sport:'',
      expandedRaceEvents: {},
      activeRaceTab: {}
    };
    
    this.showNotify = notify.createShowQueue();
    this.slider = null;
  }
  
  toggleRaceEvent = (week) => {
    this.setState(prevState => ({
      expandedRaceEvents: {
        ...prevState.expandedRaceEvents,
        [week]: !prevState.expandedRaceEvents[week]
      }
    }));
  };
  
  setActiveRaceTab = (week, tab) => {
    this.setState(prevState => ({
      activeRaceTab: {
        ...prevState.activeRaceTab,
        [week]: tab
      }
    }));
  };

// for dynamic table headers

 headerConfigs = {
  soccer: [
    { key: "week", label: "GW" },
    { key: "opponent", label: "OPP" },
    { key: "score", label: "Pts", tooltip: "Points" },
    { key: "minutes", label: "MP", tooltip: "Minutes Played" },
    { key: "goals", label: "GS", tooltip: "Goals Scored" },
    { key: "assists", label: "A", tooltip: "Assists" },
    { key: "clean_sheets", label: "CS", tooltip: "Clean Sheets" },
    { key: "goals_conceded", label: "GC", tooltip: "Goals Conceded" },
    { key: "own_goals", label: "OG", tooltip: "Own Goals" },
    { key: "penalty_saves", label: "PS", tooltip: "Penalties Saved" },
    { key: "penalty_misses", label: "PM", tooltip: "Penalties Missed" },
    { key: "yellow_cards", label: "YC", tooltip: "Yellow Cards" },
    { key: "red_cards", label: "RC", tooltip: "Red Cards" },
    { key: "saves", label: "S", tooltip: "Saves" },
    { key: "tsb", label: "TSB", tooltip: "Team Selection %" },
    // { key: "salary", label: "SAL", tooltip: "Salary" }
  ],
  cricket: [
    { key: "week", label: "GW" },
    { key: "opponent", label: "OPP" },
    { key: "batting_runs", label: "Runs" },
    { key: "batting_fours", label: "4s" },
    { key: "batting_sixes", label: "6s" },
    { key: "batting_strike_rate", label: "SR" },
    { key: "bowling_overs", label: "Overs" },
    { key: "bowling_maiden_overs", label: "Maidens" },
    { key: "bowling_wickets", label: "Wickets" },
    { key: "bowling_economy_rate", label: "Econ" },
    { key: "catch", label: "Catches" },
    { key: "stumping", label: "Stumping" },
    { key: "run_out", label: "Run Outs" },
    { key: "man_of_match", label: "MOM" },
    //  { key: "score", label: "SAL", tooltip: "Salary" }
  ]
};
renderHeaders() {
  const { sport } = this.state;
  const headers = this.headerConfigs[sport];

  return headers.map((h) => (
    <th className={`${h.label !== 'GW' && h.label !== 'OPP'  ? 'bb' : '' }`} key={h.label} id={`${h.label}Header`}>
      {h.label}
      
      {h.tooltip && (
        <Tooltip
          isOpen={this.state.tooltipOpen?.[`${h.label}Header`]}
          target={`${h.label}Header`}
          toggle={() => this.toggleChanges(`${h.label}Header`)}
        >
          {h.tooltip}
        </Tooltip>
      )}
    </th>
  ));
}

renderOpponentCell(match) {
  const { sport, PlayerCardData } = this.state;

  if (sport === "soccer") {
    return (
      <div style={{minWidth:130}}>
        <img
          src={Utils.teamFlagUrl(`${PlayerCardData.team_abbreviation !== match.home ? match.home_flag : match.away_flag}`) || ""}
          alt="Team flag"
          width={18}
          className="player-team-flag"
        />
        <span style={{minWidth:60,display:'inline-block'}}>

        
        { `${PlayerCardData.team_abbreviation !== match.home ? match.home : match.away}`}
        
        <span className="match-result">{`${match.home_team_goal}-${match.away_team_goal}`}</span>
        </span>
        <span
          className={`match-status ${
            Number(match.home_team_goal) > Number(match.away_team_goal)
              ? "w"
              : Number(match.home_team_goal) === Number(match.away_team_goal)
              ? "d"
              : "l"
          }`}
        >
          {Number(match.home_team_goal) > Number(match.away_team_goal)
            ? "W"
            : Number(match.home_team_goal) === Number(match.away_team_goal)
            ? "D"
            : "L"}
        </span>
      </div>
    );
  }

  if (sport === "cricket") {
    return (
      <div style={{minWidth:130}}>
        <img
          src={Utils.teamFlagUrl(`${PlayerCardData.team_abbreviation !== match.home ? match.home_flag : match.away_flag}`) || ""}
          //src={Utils.teamFlagUrl(match.home_flag) || ""}
          alt="flag"
          width={18}
          className="player-team-flag"
        />
        
        <span> {`${PlayerCardData.team_abbreviation !== match.home ? match.home : match.away}`} </span>
       
        {/* <span className="match-result">
          {Number(match.home_team_score) > Number(match.away_team_score)
            ? `${match.home} Won`
            : Number(match.home_team_score) < Number(match.away_team_score)
            ? `${match.away} Won`
            : "Tie"}
        </span> */}
      </div>
    );
  }

  return null;
}


renderRows() {
  const { sport, matchData, AppMasterData } = this.state;
  const headers = this.headerConfigs[sport];

  return matchData.map((match, index) => (
 
    
    <tr key={index}>      
      {headers.map((h) => (
        <td key={h.key}>
          {h.key === "opponent" ? (
            this.renderOpponentCell(match)
          ) :
          h.key === "tsb" ? 
          `${this.state.PlayerCardData.pick_percentage}%`
          :
           h.label === "SAL" ? 
          `${AppMasterData.CURRENCY_CODE}${match[h.key]} ${REACT_APP_SALARY_SUBFFIX}`
          :  
          (
            match[h.key] || "-"
          )}
        </td>
      ))}
    </tr>
  ));
}

// calculateTotals(matchData) {
//   const { sport } = this.state;

//   if (sport === "soccer") {
//     const totals = matchData.reduce(
//       (acc, match) => {
//         acc.score += Number(match.score || 0);
//         acc.minutes += Number(match.minutes || 0);
//         acc.goals += Number(match.goals || 0);
//         acc.assists += Number(match.assists || 0);
//         acc.clean_sheets += Number(match.clean_sheets || 0);
//         acc.goals_conceded += Number(match.goals_conceded || 0);
//         acc.own_goals += Number(match.own_goals || 0);
//         acc.penalty_saves += Number(match.penalty_saves || 0);
//         acc.penalty_misses += Number(match.penalty_misses || 0);
//         acc.yellow_cards += Number(match.yellow_cards || 0);
//         acc.red_cards += Number(match.red_cards || 0);
//         acc.saves += Number(match.saves || 0);
//         return acc;
//       },
//       {
//         score: 0,
//         minutes: 0,
//         goals: 0,
//         assists: 0,
//         clean_sheets: 0,
//         goals_conceded: 0,
//         own_goals: 0,
//         penalty_saves: 0,
//         penalty_misses: 0,
//         yellow_cards: 0,
//         red_cards: 0,
//         saves: 0
//       }
//     );    
//     this.setState({ totals });
//   }

//   if (sport === "cricket") {
//     const totals = matchData.reduce(
//       (acc, match) => {
//         acc.score += Number(match.score || 0);
//         acc.batting_runs += Number(match.batting_runs || 0);
//         acc.batting_fours += Number(match.batting_fours || 0);
//         acc.batting_sixes += Number(match.batting_sixes || 0);
//         acc.bowling_wickets += Number(match.bowling_wickets || 0);
//         acc.catch += Number(match.catch || 0);
//         acc.stumping += Number(match.stumping || 0);
//         acc.run_out += Number(match.run_out || 0);
//         acc.man_of_match += Number(match.man_of_match || 0);
//         return acc;
//       },
//       {
//         score: 0,
//         batting_runs: 0,
//         batting_fours: 0,
//         batting_sixes: 0,
//         bowling_wickets: 0,
//         catch: 0,
//         stumping: 0,
//         run_out: 0,
//         man_of_match: 0
//       }
//     );

//     this.setState({ totals });
//   }
// }

calculateTotals(matchData) {
  
  const { sport } = this.state;

  if (!matchData || matchData.length === 0) {
    this.setState({ totals: {} });
    return;
  }

  const headers = this.headerConfigs[sport];

  const totals = headers.reduce((acc, h) => {
    acc[h.key] = 0; // initialize all totals to 0
    return acc;
  }, {});

  matchData.forEach(match => {
    headers.forEach(h => {
      if (h.key !== "week" && h.key !== "opponent" && h.key !== "tsb" && h.key !== "sal") {
        // Only sum numeric columns
        totals[h.key] += Number(match[h.key] || 0);
      }
    });
  });

  this.setState({ totals });
}


renderTotalsRow() {
  const { t } = this.props;
  const { sport, totals, AppMasterData } = this.state;
  const headers = this.headerConfigs[sport];

  return (
    <tr className="totals-row">
      {headers.map((h, index) => (
        <td key={h.key}>
          {index === 0 ? <strong>{t('PLAYERCARD_TOTALS')}</strong> :
          h.label == "SAL" ? 
            <strong>{`${AppMasterData.CURRENCY_CODE}`}{totals[h.key] || ""}{REACT_APP_SALARY_SUBFFIX}</strong>
          :
            <strong>{totals[h.key] || "-"}</strong>
          }
        </td>
      ))}
    </tr>
  );
}





// for dynamic table headers


  showFullPos =(playerPosition,id)=>{
    // Motorsports specific positions
    if (id == 15) {
      if (playerPosition === 'CR') {
        return 'Constructor';
      }
      if (playerPosition === 'DR') {
        return 'Driver';
      }
    }
    // Cricket positions
    if (id == 7) {
      const position = fullPositionNameCric.find(p => p.position_code == playerPosition);
      return position?.position_display_name;
    }
    // Other sports (soccer, etc.)
    const position = fullPositionName.find(p => p.position_code == playerPosition);
    return position?.position_display_name;
  }
  
     toggleChanges = (id) => {
      this.setState((prevState) => ({
        tooltipOpen: {
          ...prevState.tooltipOpen,
          [id]: !prevState.tooltipOpen[id],
        },
      }));
    };

  PlayerViewToggle = (bool) => {
    this.setState(
      {
        isPlayerRoleView: bool,
      },
      () => {
        const { SelectedWeek } = this.state;
        if (!_.isNull(this.slider)) {
          this.slider.slickGoTo(Number(SelectedWeek) - 1);
        }
      }
    );
  };

  GetMasterData = () => {
    const { PlayerParam } = this.state;
    Http.post(API.GET_PLAYERCARD_SL_MASTER_DATA, PlayerParam)
      .then((response) => {
        this.setState(
          {
            MasterData: response.data,
          //  SelectedWeek: this.props.SelectedWeekCard ? this.props.SelectedWeekCard : response.data.active_week,
            PlayerCardData:response.data,
             posting: false
          },
          () => {
            const { PlayerParam, SelectedWeek } = this.state;
            //this.calculateMatchData(response.data);
             if (!response.data?.weekly_scores) return;
            const matchData = response.data.weekly_scores;
            matchData.reverse();
         
            // For motorsports: Initialize latest race event to be expanded with 'qualifying' as default tab
            if (this.props.selected_league && this.props.selected_league.sports_id == 15 && response.data.weekly_scores && response.data.weekly_scores.length > 0) {
              // Find the latest week (highest week number)
              const latestRaceEvent = [...response.data.weekly_scores].sort((a, b) => (b.week || 0) - (a.week || 0))[0];
              if (latestRaceEvent && latestRaceEvent.week) {
                this.setState({
                  expandedRaceEvents: {
                    [latestRaceEvent.week]: true
                  },
                  activeRaceTab: {
                    [latestRaceEvent.week]: 'qualifying'
                  }
                });
              }
            }

          this.setState({ matchData });
          this.calculateTotals(matchData);

            this.GetPlayercard({ ...PlayerParam, week: SelectedWeek });
          }
        );
      })
      .catch((error) => {
        this.setState({ posting: false });
        console.error(error);
      });
  };

  GetPlayercard = (param) => {
    return
    this.setState({
      statsposting: true,
      // PlayerCardData: []
    });
    Http.post(API.GET_PLAYERCARD_SL, param)
      .then((response) => {
        this.setState(
          {
            posting: false,
            statsposting: false,
            PlayerCardData: _.isUndefined(response.data.player_card)
              ? response.data
              : response.data.player_card,
          },
          () => {
            const { SelectedWeek } = this.state;
            if (!_.isNull(this.slider)) {
              this.slider.slickGoTo(Number(SelectedWeek) - 1);
            }
          }
        );
      })
      .catch((error) => {
        this.setState({
          posting: false,
          statsposting: false,
        });
        console.error(error);
      });
  };

  showImage(item) {
   if (item.player_image) {
      return item.jersey
    } else if (item.jersey) {
      return item.jersey
    } else {
      return Images.DEFAULT_JERSEY
    }
  }


  componentDidMount() {
    document.body.style.overflow = "hidden";
    const { selected_league, Player } = this.props;
    const { is_single_player } = this.state;
    const { league_id, sports_id } = selected_league;
    const contest_id = JSON.parse(localStorage.getItem('contestData')).contest_id
    // return
    let PlayerParam = {
      league_id: league_id,
      sports_id: sports_id,
      player_team_id: Player.player_team_id,
      player_uid: Player.player_uid,
      ...(is_single_player ? { is_pick_percentage_req: 0 } : {}),
      contest_id
    };

  
    this.setState(
      {
        sport:selected_league.sports_id == 7 ? "cricket" : 'soccer',
        PlayerParam,
      },
      () => this.GetMasterData()
    );
    
  }

   componentDidUpdate(prevProps) {
    if (prevProps.Player !== this.props.Player) {
    }
  }
   // calculateMatchData(PlayerCardData) {
   
      
    //if (!PlayerCardData?.weekly_scores) return;

    // const matchData = PlayerCardData.weekly_scores.map((game) => ({
    //   gw: game.week,
    //   opponent: {
    //     badge: `${PlayerCardData.team_abbreviation !== game.home ? game.home_flag : game.away_flag}`,
    //     name: `${PlayerCardData.team_abbreviation !== game.home ? game.home : game.away}`,
    //     result: `${game.home_team_goal}-${game.away_team_goal}`,
    //     status: '',
    //   },
    //   pts: game.score,
    //   mp: game.minutes,
    //   gs: game.goals,
    //   a: game.assists,
    //   cs: game.clean_sheets,
    //   gc: game.goals_conceded,
    //   og: game.own_goals,
    //   ps: game.penalty_saves,
    //   pm: game.penalty_misses,
    //   yc: game.yellow_cards,
    //   rc: game.red_cards,
    //   s: game.saves,
    //   home_team_goal: game.home_team_goal,
    //   away_team_goal: game.away_team_goal,
    //   tsb: `${PlayerCardData.pick_percentage}%`, // You can use PlayerCardData.pick_percentage
    //   price: ``, // Salary
    //   sal: PlayerCardData.salaries?.[String(game.week)] || PlayerCardData.salary, // ✅ Salary per GW
    // }));

  //  this.setState({ matchData });
//  }
  
  // calculateTotals(matchData) {

  //   const totals = matchData.reduce(
  //     (acc, match) => {
  //       acc.pts += Number(match.pts || 0);
  //       acc.mp += Number(match.mp || 0);
  //       acc.gs += Number(match.gs || 0);
  //       acc.a += Number(match.a || 0);
  //       acc.cs += Number(match.cs || 0);
  //       acc.gc += Number(match.gc || 0);
  //       acc.og += Number(match.og || 0);
  //       acc.ps += Number(match.ps || 0);
  //       acc.pm += Number(match.pm || 0);
  //       acc.yc += Number(match.yc || 0);
  //       acc.rc += Number(match.rc || 0);
  //       acc.s += Number(match.s || 0);
  //       return acc;
  //     },
  //     {
  //       pts: 0,
  //       mp: 0,
  //       gs: 0,
  //       a: 0,
  //       cs: 0,
  //       gc: 0,
  //       og: 0,
  //       ps: 0,
  //       pm: 0,
  //       yc: 0,
  //       rc: 0,
  //       s: 0,
  //     }
  //   );

  //   this.setState({ totals });
  // } 

  componentWillUnmount() {
    document.body.style.overflow = "unset";
  }

  AddPlayer = (player) => {
    const {
      LineupList,
      RosterMasterData,
      t,
      ALL_POSITION,
      lineup_roster_limit,
      toggle,
      next_week,
      IS_TRASFER,
      SALARY_CAP,
    } = this.props;
    let param = {
      next_week,
      lineup_roster_limit,
      player,
      lineup: LineupList,
      salary: Utils.AvailableSalary(SALARY_CAP, LineupList),
      max_player_per_team: RosterMasterData.max_player_per_team,
      all_position: ALL_POSITION,
    };
    Utils.AddPlayerToLineup(param)
      .then((response) => {
        if (IS_TRASFER) {
          Utils.setTransferData(player, "1");
        }
        this.props.updateLineupList(response);
        toggle();
      })
      .catch((err) => {
        this.showNotify(t(err), "error", 5000);
        toggle();
      });
  };

  RemovePlayer = (player) => {
    const { LineupList, toggle, IS_TRASFER, next_week, joined_week } =
      this.props;
    let param = {
      player: player,
      lineup: LineupList,
      next_week,
      joined_week,
    };
    Utils.RemovePlayerFromLineup(param).then((response) => {
      if (IS_TRASFER) {
        Utils.setTransferData(player, "0");
      }
      this.props.updateLineupList(response);
      toggle();
    });
  };

  SelectWeekHandle = (item) => {
    this.setState(
      {
        SelectedWeek: item.week,
      },
      () => {
        const { PlayerParam, SelectedWeek } = this.state;
        this.GetPlayercard({ ...PlayerParam, week: SelectedWeek });
      }
    );
  };

  isGKPlayerRole = () => {
    const { Player, LineupList } = this.props;
    let _flt = _.filter(LineupList, (item) => {
      return (
        item.player_uid != Player.player_uid && item.position == Player.position
      );
    });
    return !_.isEmpty(_flt) ? _flt[0].player_role : null;
  };

   toggleTabs = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab },()=>{
        if(tab == '2' && _.isEmpty(this.state.FixturesList)){
          this.getPlayerFixture()
        }
      });
    }
  };

  getPlayerFixture = () => {
    const { selected_league, Player } = this.props;
    const { league_id } = selected_league;
    this.setState({posting:true})
    let param ={
      league_id: league_id,
      player_team_id: Player.player_team_id,
      player_id: Player.player_id,
    }
    Http.post(API.GET_PLAYER_UPCOMMING_FIXTURE, param).then(response => {
      const { data } = response.data;
      
      
      let match_list_clone = _.cloneDeep(response.data)
      let match_list = {}
      _.forEach(match_list_clone, (item, key) => {
        if (_.isEmpty(match_list)) {
          match_list = item
        } else {
          match_list = _.concat(match_list, item)
        }
      })

      this.setState({
        FixturesList: response.data
      }, () => {
        
        
        this.setState({
          posting: false,
         // FixturesList: match_list
        })
      })
    }).catch(error => {
      console.error(error)
    });

  }

  toggleFixtureDetail =()=>{
      
  }

  toggle =()=>{

  }



  render() {
    const {
      isOpen,
      toggle,
      t,
      Player,
      isLineupPlayer,
      LineupList,
      PlayerRoleInit,
      i18n,
      selected_league,
      enablePlayerRoleInit,
      next_week,
      joined_week,
      IS_TRASFER,
      SALARY_CAP,
      tooltipOpen,
      active_week
    } = this.props;
    const {
      isPlayerRoleView,
      posting,
      statsposting,
      MasterData,
      SelectedWeek,
      PlayerCardData,
      is_single_player,
      CurrentLineup,
      constant_pos,
      SelectedLeague,
      AppMasterData,
      FixturesList,
      CurrentFixtuerSelected,
      openingItem,
      opening,
      totals,
      matchData
    } = this.state;
    const {
      // position = '',
      team_abbreviation = '',
      // away = '--',
      // home = '--',
    } = MasterData;

    const {
      selected_by = null,
      avg_form = null,
      total_points = null,
      pick_percentage = null,
      master_data = [],
      roster_detail = {},
      salary = null,
    } = MasterData;

    var SliderSettings = {
      infinite: false,
      // speed: 500,
      arrows: true,
      slidesToShow: i18n.language === "ar" ? 3 : 3,
      slidesToScroll: i18n.language === "ar" ? 1 : 1,
      responsive: [
        {
          breakpoint: 767,

          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
          }
        },
      ]
    };
    const contestData = JSON.parse(localStorage.getItem('contestData'))
    const PlayerRoleCaptain = ({ Player }) => {
      if (selected_league.sports_config.is_captain_available == 0) return null;
      return (
        <a
          className={`player-role-btn ${Player.player_role == 1 ? " active" : ""
            }`}
          onClick={true ? () => PlayerRoleInit(Player, "1") : null}
        >
          
            <span className="check" />
          
          <span className="title">
            <Trans>Make Captain</Trans>
          </span>
          <div>
            {Player.player_role == 1 ? <img src={Images.CAPTAIN} className="role-img" alt="" /> :
            <img src={Images.CAPTAIN_BLUE} className="role-img" alt="" />}
          </div>
        </a>
      );
    };
    const PlayerRoleViceCaptain = ({ Player }) => {
      if (selected_league.sports_config.is_vicecaptain_available == 0)
        return null;
      return (
        <a
          className={`player-role-btn crow${Player.player_role == 2 ? " active" : ""
            }`}
          onClick={true ? () => PlayerRoleInit(Player, "2") : null}
        >
          <div>
            <span className="check" />
          </div>
          <div className="title">
            <Trans>Make Vice-Captain</Trans>
          </div>
          <div>
            {Player.player_role == 2 ?
              <img src={Images.VICE_CAPTAIN_W} className="role-img" alt="" />
              : <img src={Images.VICE_CAPTAIN} className="role-img" alt="" />}
          </div>
        </a>
      );
    };

    let current_date = '';

    const FixtureDetails = () => {
        const { MatchSummary } = this.state;
        return (
            _.map(MatchSummary.stats, (item, idx) => {
                return (
                    (!_.isEmpty(item.home) || !_.isEmpty(item.away)) &&
                    <div className="fixture-details" key={idx}>
                        <div className="title dl-clrs">{MatchSummary.stats_lang[idx]}</div>
                        <div className="content">
                            <div className="cell">
                                {
                                    is_single_player ?
                                        <div>
                                            {item.home}
                                        </div>
                                        :
                                        <>
                                            {
                                                item.home ?
                                                    _.map(item.home, (obj, index) => {
                                                        return (
                                                            <div title={obj.full_name} key={index}>
                                                                <span className="text-ellipsis">{obj.full_name}</span>{" "}
                                                                {
                                                                    Number(obj.value) > 0 &&
                                                                    `(${obj.value})`
                                                                }
                                                            </div>
                                                        )
                                                    })
                                                    :
                                                    "--"
                                            }
                                        </>
                                }

                            </div>
                            <div className="cell">
                                {
                                    is_single_player ?
                                        <div>
                                            {item.away}
                                        </div>
                                        :
                                        <>
                                            {
                                                item.away ?
                                                    _.map(item.away, (obj, index) => {
                                                        return (
                                                            <div title={obj.full_name} key={index}>
                                                                <span className="text-ellipsis">{obj.full_name}</span>{" "}
                                                                {
                                                                    Number(obj.value) > 0 &&
                                                                    `(${obj.value})`
                                                                }
                                                            </div>
                                                        )
                                                    })
                                                    :
                                                    "--"
                                            }

                                        </>
                                }
                            </div>
                        </div>
                    </div>
                )
            })
        )
    }


    
    return (
      <div className="mob-full-modal">

      
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        className="custom-modal xplc-modal new-modal-ui"
        backdropClassName="full-view-backdrop"
      >
        
        <div className={`new-player-card ${selected_league && selected_league.sports_id == 15 ? 'motorsports' : ''}`}>
          <i className="close-btn icon-cancel" onClick={toggle} />
				{PlayerCardData.player_other_status !== '0' && 	<div className={`injury-banner ${PlayerCardData.player_other_status == "1" ? 'gray' :  PlayerCardData.player_other_status == "2"  ? 'red' : PlayerCardData.player_other_status == "3" ? 'yellow' : '' }`}>
             {t('PLAYERCARD_STATUS_BANNER', { name: Player?.full_name })}{" "}
             {
                PlayerCardData.player_other_status == "1" && 
                <span >
                  {t('PLAYERCARD_STATUS_SUSPENDED')}
                </span>
              }
              {
                PlayerCardData.player_other_status == "2" && 
                <span>
                  {t('PLAYERCARD_STATUS_ELIMINATED')}
                </span>
              }
              {
                PlayerCardData.player_other_status == "3" && 
                <span>
                  {t('PLAYERCARD_STATUS_INJURED')}
                </span>
              }
          </div>}

          {/* Player Header */}
					<div className="player-header">
						<div className="player-jersey">
							<img
								src={Utils.playerJersyUrl(Player?.jersey) || ""}
								alt="Player Jersey"
							/>
						</div>
						<div className="player-info">
							<div className="position">{this.showFullPos(PlayerCardData?.position, PlayerCardData?.sports_id)}</div>
							<div className="player-name">{PlayerCardData?.full_name}</div>
							<div className="team-name">{PlayerCardData?.team_abbreviation}</div>
						</div>
					</div>
        {/* Stats Row */}
					<div className="stats-row">
						<div className="stat-item">
              <div className="stat-label">{t('Salary')}</div>
							<div className="stat-value">{`${AppMasterData.CURRENCY_CODE}`}{PlayerCardData?.salary} {REACT_APP_SALARY_SUBFFIX}</div>
						</div>
						{contestData && contestData.sports_id == 15 ? (
							<>
								<div className="stat-item">
                  <div className="stat-label">{SelectedLeague?.week_abbr?.[active_week] || ''} {t('PLAYERCARD_PTS')}</div>
									<div className="stat-value">
										{PlayerCardData?.weekly_scores?.find(
											(game) => String(game.week) == String(active_week)
										)?.score || "--"}
									</div>
								</div>
								<div className="stat-item">
                  <div className="stat-label">{t('PLAYERCARD_TOTAL_PTS')}</div>
									<div className="stat-value">
										{(() => {
											// For motorsports, get the latest race event's total points (sum of qualifying + race)
											if (PlayerCardData?.weekly_scores && PlayerCardData.weekly_scores.length > 0) {
												const latestRaceEvent = [...PlayerCardData.weekly_scores].sort((a, b) => (b.week || 0) - (a.week || 0))[0];
												if (latestRaceEvent && latestRaceEvent.display_card) {
													const qualifyingPoints = latestRaceEvent.display_card.qualifying 
														? _.sumBy(latestRaceEvent.display_card.qualifying, (item) => parseFloat(item.Point) || 0)
														: 0;
													const racePoints = latestRaceEvent.display_card.race
														? _.sumBy(latestRaceEvent.display_card.race, (item) => parseFloat(item.Point) || 0)
														: 0;
													const latestTotal = qualifyingPoints + racePoints;
													return latestTotal > 0 ? latestTotal : (totals.score || '-');
												}
											}
											return totals.score ? totals.score : '-';
										})()}
									</div>
								</div>
								<div className="stat-item">
                  <div className="stat-label">{t('PLAYERCARD_TSB')}</div>
									<div className="stat-value">{PlayerCardData?.pick_percentage}%</div>
								</div>
							</>
						) : (
							<>
								<div className="stat-item">
                  <div className="stat-label">{t('Form')}</div>
									<div className="stat-value">{PlayerCardData?.avg_form}</div>
								</div>
								<div className="stat-item">
                  <div className="stat-label">{SelectedLeague?.week_abbr?.[active_week] || `GW ${active_week}`} {t('PLAYERCARD_PTS')}</div>
									<div className="stat-value">
										{PlayerCardData?.weekly_scores?.find(
											(game) => String(game.week) == String(active_week)
										)?.score || "--"}
									</div>
								</div>
								<div className="stat-item">
                  <div className="stat-label">{t('PLAYERCARD_TOTAL_PTS')}</div>
									<div className="stat-value">
										{
											totals.score ? 
											<>{totals.score}</> :
											<>-</>
										}
									</div>
								</div>
								<div className="stat-item">
                  <div className="stat-label">{t('PLAYERCARD_TSB')}</div>
									<div className="stat-value">{PlayerCardData?.pick_percentage}%</div>
								</div>
							</>
						)}
					</div>
          
          
          <Fragment>
            {enablePlayerRoleInit &&
              isPlayerRoleView &&
              Utils.IsPlayerField(Player, LineupList) &&
              isLineupPlayer &&
              (CurrentLineup.user_join_count == 0 ||
                next_week == joined_week ||
                IS_TRASFER) ? (
              <div className="player-card-body">
                {constant_pos &&
                  Player.position == constant_pos.P0 &&
                  this.isGKPlayerRole() != null ? (
                  <Fragment>
                    {Player.player_role == 0 && this.isGKPlayerRole() == 0 && (
                      <Fragment>
                        <PlayerRoleCaptain Player={Player} />
                        <PlayerRoleViceCaptain Player={Player} />
                      </Fragment>
                    )}

                    {((Player.player_role == 1 && this.isGKPlayerRole() == 0) ||
                      (Player.player_role == 0 &&
                        this.isGKPlayerRole() == 1)) && (
                        <Fragment>
                          <PlayerRoleViceCaptain Player={Player} />
                        </Fragment>
                      )}
                    {((Player.player_role == 2 && this.isGKPlayerRole() == 0) ||
                      (Player.player_role == 0 &&
                        this.isGKPlayerRole() == 2)) && (
                        <Fragment>
                          <PlayerRoleCaptain Player={Player} />
                        </Fragment>
                      )}
                  </Fragment>
                ) : (
                  <Fragment>
                    <PlayerRoleCaptain Player={Player} />
                    <PlayerRoleViceCaptain Player={Player} />
                  </Fragment>
                )}
              </div>
            ) : (
              <div className="player-card-body">
                {posting ? (
                  <Utils.Spinner />
                ) : (
                  <Fragment>
                    {
                      // Utils.isCapAvailable(LineupList) &&
                      //   Utils.isVCAvailable(LineupList) && !IS_TRASFER &&
                      <div>
                        {/* Motorsports Performance View - No Tabs */}
                        {selected_league && selected_league.sports_id == 15 ? (
                          <div className="motorsports-performance">
                            <div className="performance-header">
                              <h3>{t('PLAYERCARD_PERFORMANCE')}</h3>
                            </div>
                            <div className="race-events-list">
                              {PlayerCardData?.weekly_scores && PlayerCardData.weekly_scores.length > 0 ? (
                                _.map([...PlayerCardData.weekly_scores].reverse(), (raceEvent, idx) => {
                                  const isExpanded = this.state.expandedRaceEvents[raceEvent.week];
                                  const activeTab = this.state.activeRaceTab[raceEvent.week] || 'qualifying';
                                  const totalPoints = raceEvent.score || 0;
                                  const weekLabel = SelectedLeague?.week_label?.[raceEvent.week] || `Week ${raceEvent.week}`;
                                  const tourName = raceEvent.tournament_name || weekLabel;
                                  
                                  // Calculate points for each tab
                                  const qualifyingPoints = raceEvent.display_card?.qualifying 
                                    ? _.sumBy(raceEvent.display_card.qualifying, (item) => parseFloat(item.Point) || 0)
                                    : 0;
                                  const racePoints = raceEvent.display_card?.race
                                    ? _.sumBy(raceEvent.display_card.race, (item) => parseFloat(item.Point) || 0)
                                    : 0;
                                  
                                  // Always show total points (sum of both tabs)
                                  const displayPoints = qualifyingPoints + racePoints;
                                  
                                  return (
                                    <div key={idx} className={`race-event-item ${isExpanded ? 'expanded' : ''}`}>
                                      <div 
                                        className="race-event-header"
                                        onClick={() => this.toggleRaceEvent(raceEvent.week)}
                                      >
                                        <div className="race-event-name"><span>{tourName}</span> <span className="race-event-week">{SelectedLeague?.week_abbr?.[active_week] || ''}</span></div>
                                        <div className="race-event-points"><span className="total-label">{t('PLAYERCARD_TOTAL')}</span> <span className="total-points">{displayPoints} {t('PLAYERCARD_PTS')}</span> </div>
                                        <i className={`icon-${isExpanded ? 'up' : 'down'}`} />
                                      </div>
                                      {isExpanded && raceEvent.display_card && (
                                        <div className="race-event-details">
                                          <div className="race-tabs">
                                            <button
                                              type="button"
                                              className={`race-tab ${activeTab === 'qualifying' ? 'active' : ''}`}
                                              onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                this.setActiveRaceTab(raceEvent.week, 'qualifying');
                                              }}
                                            >
                                              {t('PLAYERCARD_QUALIFYING')}
                                            </button>
                                            <button
                                              type="button"
                                              className={`race-tab ${activeTab === 'race' ? 'active' : ''}`}
                                              onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                this.setActiveRaceTab(raceEvent.week, 'race');
                                              }}
                                            >
                                              {t('PLAYERCARD_RACE')}
                                            </button>
                                          </div>
                                          {(raceEvent.season_scheduled_date || raceEvent.event_date) && (
                                            <div className="race-event-date">
                                              {Utils.DateFormat(Utils.getUtcToLocal(raceEvent.season_scheduled_date || raceEvent.event_date), "dddd, D MMM YYYY")}
                                            </div>
                                          )}
                                          <div className="race-tab-content">
                                            {activeTab === 'qualifying' && raceEvent.display_card.qualifying ? (
                                              <div className="performance-table">
                                                <div className="performance-header-row">
                                                  <div className="perf-col-label">{t('PLAYERCARD_EVENT')}</div>
                                                  <div className="perf-col-value">{t('Value')}</div>
                                                  <div className="perf-col-points">{t('Points')}</div>
                                                </div>
                                                {_.map(raceEvent.display_card.qualifying, (item, qIdx) => (
                                                  <div key={qIdx} className="performance-row">
                                                    <div className="perf-col-label">{item.Label}</div>
                                                    <div className="perf-col-value">{item.Value || '-'}</div>
                                                    <div className="perf-col-points">{item.Point}</div>
                                                  </div>
                                                ))}
                                              </div>
                                            ) : activeTab === 'race' && raceEvent.display_card.race ? (
                                              <div className="performance-table">
                                                <div className="performance-header-row">
                                                  <div className="perf-col-label">{t('PLAYERCARD_EVENT')}</div>
                                                  <div className="perf-col-value">{t('Value')}</div>
                                                  <div className="perf-col-points">{t('Points')}</div>
                                                </div>
                                                {_.map(raceEvent.display_card.race, (item, rIdx) => (
                                                  <div key={rIdx} className="performance-row">
                                                    <div className="perf-col-label">{item.Label}</div>
                                                    <div className="perf-col-value">{item.Value || '-'}</div>
                                                    <div className="perf-col-points">{item.Point}</div>
                                                  </div>
                                                ))}
                                              </div>
                                            ) : (
                                              <div className="no-data">{t('PLAYERCARD_SCORES_UPDATE_SOON')}</div>
                                            )}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  );
                                })
                              ) : (
                                <div className="no-data">{t('PLAYERCARD_SCORES_UPDATE_SOON')}</div>
                              )}
                            </div>
                          </div>
                        ) : (
                          /* Default Stats Table with Tabs for other sports */
                          <div className="card-fixture-wrap">
                            <div className="tabs view-toggle-wrap">
                              <div className="view-toggle">
                                <button
                                  className={`xtab view-toggle-button ${
                                    this.state.activeTab === "1" ? "active" : ""
                                  }`}
                                  onClick={() => this.toggleTabs('1')}
                                >
                                  {t('PLAYERCARD_HISTORY')}
                                </button>
                                <button
                                  className={`xtab view-toggle-button ${
                                    this.state.activeTab === "2" ? "active" : ""
                                  }`}
                                  onClick={() => this.toggleTabs('2')}
                                >
                                  {t('Fixtures')}
                                </button>
                              </div>
                            </div>
                            <TabContent activeTab={this.state.activeTab}>
                              <TabPane tabId="1">
                                <div className="season-stats">
                                  <div className="season-header">
                                    <h3>{t('PLAYERCARD_THIS_SEASON')}</h3>
                                  </div>
                                  {
                                    !_.isEmpty(this.renderRows()) ?  <div className="stats-table-container">
                                      <table className="stats-table">
                                        <thead>
                                          <tr>{this.renderHeaders()}</tr>
                                        </thead>
                                        <tbody>
                                          {this.renderRows()}
                                          {this.renderTotalsRow()}
                                        </tbody>
                                      </table>
                                    </div> : 
                                    <div className="stats-table-container">
                                      <h4>{t('PLAYERCARD_NO_STATS_AVAILABLE')}</h4>
                                    </div>
                                  }
                                </div>
                              </TabPane>
                              <TabPane tabId="2">
                            <div className='pfix-row'>
                      {
                          !posting ?
                              <Col className='fixtures-list-wrap modal-fix mobile-fix myOverride'>
                                <div className="fixture-header-modal">
                                  <div>{t('Date')}</div>
                                  <div style={{ textAlign: 'center' }}>GW</div>
                                  <div style={{ textAlign: 'right' }}>OPP</div>
                                </div>
                                {/* <div className="weeek-block">{Utils.getMultiLeg().week_label[SelectedWeek]}</div> */}
                                  {FixturesList.length > 0  ? <div className="xfixtures-list xcontent-list" >
                                      { 
                                          _.map(FixturesList, (item, index) => {
                                              
                                              
                                            
                                              let firstChar = Utils.getUtcToLocal(item.season_scheduled_date, "dddd, MMM D");
                                              let ShowHeadShow = true;
                                              if (firstChar != current_date) {
                                                  current_date = firstChar
                                                  ShowHeadShow = true;
                                              }
                                              return (
                                                  <Fragment key={index}>
                                                      <div className="fixture-modal-row">
                                                        <div>{Utils.DateFormat(Utils.getUtcToLocal(item.season_scheduled_date), "dddd MMM D HH:mm")}</div>
                                                        <div style={{ textAlign: 'center' }}>{item.week}</div>
                                                        <div className="right-col-fix">
                                                            <Img style={{width:14}} src={item.flag_away} fallbacksrc={Images.DEFAULT_FLAG} alt="" />
                                                          <div {...{ className: `fx-name ${(Number(item.home_team_goal) < Number(item.away_team_goal) || Number(item.home_team_score) < Number(item.away_team_score)) ? 'winner' : ''}` }} title={item.away_team_name}>
                                                            <span className='mob-l-name'>{item.away}</span>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      {/* {
                                                          <>
                                                          <div className="weeek-block cdl-clrs cbt-match">
                                                              <span>
                                                                  {Utils.getMultiLeg().week_label[item.week]}
                                                              </span>
                                                          </div>
                                                          <div className="cweeek-block dl-clrs bt-match">
                                                            <span>
                                                            {firstChar}
                                                            </span>
                                                          </div>
                                                      </>
                                                      }

                                                      {
                                                          is_single_player ?
                                                              <>
                                                                  <div className={`is_single_player fixture-item fixture-mt ${item.season_game_uid == CurrentFixtuerSelected && !this.isMatchSummaryEmpty() ? ' active' : ''}${item.season_game_uid == openingItem ? ' opening' : ''}`} onClick={(!opening && Utils.isDateTimePast(item.season_scheduled_date, item)) ? () => this.toggleFixtureDetail(item) : null}>

                                                                      <div className="cell">
                                                                          <div {...{ className: `fx-name ${Number(item.home_score) > Number(item.away_score) ? 'winner' : ''}` }} title={item.home_full_name}>{item.home_full_name}</div>
                                                                          <figure className='fx-flag'>
                                                                              <Img src={item.home_player_image} fallbacksrc={Images.COUNTRY_FLAG} alt="" />
                                                                          </figure>
                                                                      </div>

                                                                      <div className="cell mid">
                                                                          <div className="score-capsule">

                                                                              <img src={Images.CLOCK_FMT} alt='' />
                                                                              {Utils.DateFormat(Utils.getUtcToLocal(item.season_scheduled_date), "HH:mm")}
                                                                          </div>
                                                                      </div>
                                                                      <div className="cell last">
                                                                          <figure className='fx-flag'>
                                                                              <Img src={item.away_player_image} fallbacksrc={Images.COUNTRY_FLAG} alt="" />
                                                                          </figure>
                                                                          <div {...{ className: `fx-name ${Number(item.home_score) < Number(item.away_score) ? 'winner' : ''}` }} title={item.away_full_name}>{item.away_full_name}</div>
                                                                      </div>
                                                                  </div>
                                                              </>
                                                              :
                                                              <>
                                                                  <div className={`radha fixture-item fixture-mt ${item.season_game_uid == CurrentFixtuerSelected && !this.isMatchSummaryEmpty() ? ' active' : ''}${item.season_game_uid == openingItem ? ' opening' : ''}`} onClick={(!opening && Utils.isDateTimePast(item.season_scheduled_date, item)) ? () => this.toggleFixtureDetail(item) : null}>
                                                                      <div className="cell">
                                                                          <div {...{ className: `fx-name ${(Number(item.home_team_goal) > Number(item.away_team_goal) || Number(item.home_team_score) > Number(item.away_team_score)) ? 'winner' : ''}` }} title={item.home_team_name}>
                                                                              <span className='mob-l-name'>{item.home}</span>
                                                                              {
                                                                                  // (!item.home_team_goal && Utils.isDateTimePast(item.season_scheduled_date, item)) &&
                                                                                  // <div className="fx-score-wrap">
                                                                                  //     <b>{item.home_team_score}/{item.home_wickets}</b> <small>({item.home_overs} <Trans>OVR</Trans>)</small>
                                                                                  // </div>
                                                                              }
                                                                          </div>
                                                                          <figure className='fx-flag'>
                                                                              <Img src={item.flag_home} fallbacksrc={Images.DEFAULT_FLAG} alt="" />
                                                                          </figure>
                                                                      </div>


                                                                      <div className="cell mid">
                                                                          <div className="score-capsule schedule-update">
                                                                              <img src={Images.CLOCK_FMT} alt='' />
                                                                              {

                                                                                  Utils.DateFormat(Utils.getUtcToLocal(item.season_scheduled_date), "HH:mm")
                                                                              }
                                                                          </div>
                                                                      </div>

                                                                      <div className="cell last">
                                                                          <figure className='fx-flag'>
                                                                              <Img src={item.flag_away} fallbacksrc={Images.DEFAULT_FLAG} alt="" />
                                                                          </figure>
                                                                          <div {...{ className: `fx-name ${(Number(item.home_team_goal) < Number(item.away_team_goal) || Number(item.home_team_score) < Number(item.away_team_score)) ? 'winner' : ''}` }} title={item.away_team_name}>
                                                                              
                                                                              <span className='mob-l-name'>{item.away}</span>
                                                                             
                                                                          </div>
                                                                      </div>

                                                                  </div>
                                                              </>
                                                      }
                                                      {
                                                          item.season_game_uid == CurrentFixtuerSelected &&
                                                          ''
                                                          // <FixtureDetails />
                                                      } */}
                                                  </Fragment>
                                              )
                                          })
                                      }
                                  </div>
                                  : 
                                    <h4 className="no-data-fix">{t('No Data Available')}</h4>
                                  }
                              </Col>
                              :
                              <Utils.Spinner />
                      }

                  </div>
                            </TabPane>
                          </TabContent>
                        </div>
                        )}
                      </div>
                    }
                  </Fragment>
                )}
              </div>
            )}

            
          </Fragment>
            {isLineupPlayer &&
              (CurrentLineup.user_join_count == 0 ||
                next_week == joined_week ||
                IS_TRASFER) && (
               <div className="action-buttons">
                  { isPlayerRoleView ? 
                    <button className="btn-primary"  onClick={() => this.PlayerViewToggle(false)}>
                      {t('View Full Profile')}
                    </button> : 
                    <button  onClick={() => this.PlayerViewToggle(true)} className="btn-primary">
                      {t('Back')}
                    </button>
                  }
                  {
                    Utils.IsPlayerExist(Player, LineupList) ? (
                      <button
                        className="btn-secondary"
                        onClick={() => this.RemovePlayer(Player)}
                      >
                        <Trans>
                          Remove
                        </Trans>
                      </button>
                    ) : (
                      <button
                        className="btn-secondary"
                        onClick={() => this.AddPlayer(Player)}
                      >
                        <Trans>
                          Add
                        </Trans>
                      </button>
                    )
                  }
                </div>
              )}
        </div>
      </Modal>
      </div>

    );
  }
}
PlayerCard.defaultProps = {
  Player: {},
  isLineupPlayer: false,
  PlayerRoleInit: () => { },
  updateLineupList: () => { },
  RosterMasterData: [],
  LineupList: [],
  joined_week: null,
};
export default ReduxHOC(PlayerCard);
